import { Box, Flex, Stack, Text } from '@chakra-ui/core'
import { PopRecipients } from '../fileds/PopRecipients'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { TitleField } from '../fileds/TitleField'
import { BodyField } from '../fileds/BodyField'
import { BtnTextField } from '../fileds/BtnTextField'
import { UploadMediaSection } from '../fileds/UploadMediaSection'

import { PushTitleField } from '../fileds/PushTitleField'
import { PopSwitch } from '../fileds/PopSwitch'
import { PopFormValues, PopType } from 'components/PopCreation/types'
import { ProfileImageField } from '../fileds/ProfileImageField'
import { PushMessageField } from '../fileds/PushMessageField'
import useLocaleText from 'components/useLocaleText'
import { LinkUrlField } from '../fileds/LinkUrlField'
import { getDefaultProfileImageUrl } from '../utils'

export const PopFormDefault = ({ isLinkPop = false }: { isLinkPop?: boolean }) => {
  const { control } = useFormContext<PopFormValues>()
  const pick_audience = useLocaleText('pick_audience')
  const enable_push_notification = useLocaleText('enable_push_notification', true)
  const push_title = useLocaleText('push_title', true)
  const push_body = useLocaleText('push_body', true)
  const push_title_placeholder = useLocaleText('push_title_placeholder', true)
  const push_body_placeholder = useLocaleText('push_body_placeholder', true)

  return (
    <Stack style={{ gap: '15px' }}>
      <Stack style={{ gap: '10px' }} mt={4}>
        <ProfileImageField defaultImageUrl={getDefaultProfileImageUrl(isLinkPop ? PopType.LinkPop : PopType.Default)} />
        <TitleField requireNonBlank={isLinkPop} />
        {isLinkPop ? (
          <LinkUrlField />
        ) : (
          <BodyField keyName="data.pop_body" label="pop_body" placeholder="pop_body_placeholder" />
        )}
        <BtnTextField keyName="data.ack_btn_text" label="ack_btn" placeholder="ack_btn_placeholder" />
      </Stack>

      <Box>
        <Text fontSize="14px" fontWeight="bold" color="gray.500" mb={2}>
          {pick_audience}
        </Text>
        <PopRecipients />
      </Box>

      {!isLinkPop && <UploadMediaSection />}

      <Flex flexDir="column" mt={2} w={{ base: '100%', md: 'calc(50% - 10px)' }}>
        <Flex alignItems="center" justifyContent="space-between">
          <Text fontSize="14px" fontWeight="bold" color="gray.500" mb={2} w="100%">
            {enable_push_notification}
          </Text>
          <PopSwitch name="is_send_push_notification" />
        </Flex>

        <PushTitleField
          keyName="data.push_title"
          label={push_title}
          placeholder={push_title_placeholder}
          keySwitch="is_send_push_notification"
        />
        <PushMessageField
          keyName="data.push_body"
          label={push_body}
          placeholder={push_body_placeholder}
          keySwitch="is_send_push_notification"
        />
      </Flex>
      <Controller
        name="pop_type"
        control={control}
        defaultValue={isLinkPop ? PopType.LinkPop : PopType.Default}
        as={<Box display="none" />}
      />
      <Controller name="rid" control={control} as={<Box display="none" />} />
    </Stack>
  )
}
